export const SheetSectionEmptyText = ({ text }: { text: string }) => {
  return <p className="text-sm font-normal text-slate-400">{text}</p>;
};
